import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Permission from "../../assets/imgs/Permission.png";

import Bot from "../../assets/icons/MessageBot.svg";

import HomeLayout from "../../components/layouts/HomeLayout";
import Advice from "./components/Advice";
import Carousel from "./components/Carousel";

const Home = () => {
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    // navigator.geolocation.getCurrentPosition(
    //     error =>{
    //         setVisibility(true)
    //         console.log(error)
    //     }
    // )
    if ("geolocation" in navigator) {
      setVisibility(false);
    } else {
      setVisibility(true);
    }
  }, []);

  const handleButtonClick = () => {
    setVisibility(false); // Update state when the button is clicked
  };

  return (
    <HomeLayout>
      <h1 className="ml-2 text-blue lg:text-xl">Welcome</h1>

      <Advice />

      <section className=" action px-2 mt-[30px] w-full flex justify-between items-center">
        <Link to="/settings" aria-label="settings">
          <button
            className=" active:p-[6px] rounded-full shadow shadow-black p-1"
            name="Settings"
          >
            <ion-icon name="settings-outline"></ion-icon>
          </button>
        </Link>

        <Link to="/map" aria-label="map">
          <button
            className=" active:p-[6px] rounded-full shadow shadow-black p-1"
            name="Map button"
          >
            <ion-icon name="map-outline"></ion-icon>
          </button>
        </Link>

        <Link to="/bot" aria-label="bot">
          <button
            className=" active:p-[6px] rounded-full shadow shadow-black p-1"
            name="Bot"
          >
            <img alt="Bot button" src={Bot} />
          </button>
        </Link>
      </section>

      <div
        className={`${
          visibility ? "" : "hidden"
        } absolute z-10 top-[40%] bg-white p-4 w-4/5 ml-4 shadow shadow-black rounded-[20px]`}
      >
        <img
          className="w-3/4 mx-1 my-2"
          src={Permission}
          alt="Turn on location"
        />

        <h1 className="text-blue">Turn on permission and reload</h1>

        <p>Your location info helps us function better</p>

        <button
          onClick={() => {
            handleButtonClick();
          }}
          className="active:bg-blue active:text-white border-blue rounded-xl bg-white border border-blue w-full shadow shadow-black my-2 px-5 py-2.5 text-blue"
        >
          Ok
        </button>
      </div>

      <Carousel />
      {/* <div className="border-y p-2 text-sm font-medium text-blue mt-6 bg-white">
                <p>First aid tips</p>
            </div> */}
    </HomeLayout>
  );
};

export default Home;
